export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setExportLoading(state, exportLoading) {
    state.exportLoading = exportLoading;
  },
  setDeliveredReportTableData(state, tableData) {
    state.tableData = tableData;
  },
  setDeliveredReportChartData(state, chartData) {
    state.chartData = chartData;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/delivered-provider/store/mutations.js